/* production_v2 */
const config = {
    logLevel: "error",
    baseHref: "/",
    title: "widgets",
}
export default config

